import { useEffect, useMemo } from 'react';
import debounce from 'lodash.debounce';

import { useToggle } from 'ui-components/hooks/use-toggle';

import { usePusherEvent } from '../../../hooks/use-pusher-event';
import { CSV_ORDER_IMPORT_JOB_COMPLETE } from '../../../services/pusher-service/pusher-contract-messages';
import { useProtectedSyncInventory } from '../../../pages/settings/inventory-sources/use-protected-sync-inventory';

export const useInventorySyncOnImportComplete = () => {
  const { activate: startListening, deactivate: stopListening, isActivated: isListening } = useToggle(false);
  const protectSyncInventory = useProtectedSyncInventory();

  const debouncedSync = useMemo(() => {
    // Call syncConsolidatedInventoryCounts 60 seconds after the last Job complete event OR 3 minutes after the first
    return debounce(protectSyncInventory, 60000, { maxWait: 180000 });
  }, [protectSyncInventory]);
  const debouncedStopListening = useMemo(() => {
    return debounce(stopListening, 120000);
  }, [stopListening]);

  usePusherEvent(CSV_ORDER_IMPORT_JOB_COMPLETE, () => {
    if (isListening) {
      debouncedSync();
      debouncedStopListening();
    }
  });

  useEffect(() => {
    return () => {
      // Cleanup the debounced functions on component unmount
      debouncedSync.cancel();
      debouncedStopListening.cancel();
    };
  }, [debouncedSync, debouncedStopListening]);

  return startListening;
};
